import React from "react";
import { Grid, Typography, Card, CardContent, Box } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import useStylesThemes from "../../css/globalTheme";

export function sorteGroupeActivity(selectedValues) {
  // Tri des activités par parentNom, longDate, et HeureDebut
  // const sortedActivities = [...selectedValues].sort((a, b) => {
  //   if (a.parentNom !== b.parentNom) {
  //     return a.parentNom.localeCompare(b.parentNom);
  //   }
  //   if (a.longDate !== b.longDate) {
  //     return a.longDate.localeCompare(b.longDate);
  //   }
  //   return a.HeureDebut - b.HeureDebut;
  // });

  // Création d'un objet pour regrouper les activités par catégorie et par date
  const groupedActivities = {};

  selectedValues.forEach((activity) => {
    const { parentNom, longDate } = activity;
    if (!groupedActivities[parentNom]) {
      groupedActivities[parentNom] = {};
    }
    if (!groupedActivities[parentNom][longDate]) {
      groupedActivities[parentNom][longDate] = [];
    }

    groupedActivities[parentNom][longDate].push(activity);
  });

  return groupedActivities;
}

export const reorganizeActivities = (activities, activitesInfos) => {
  if (!activities) return {};
  if (!activitesInfos) return activities;
  const reorganizedActivities = {};

  // Filtrer les activités réattribuées et non traitées
  const reattribuerNonTreated = activitesInfos.filter(activity => isActivityReattributed(activity.nom, activitesInfos));

  if (reattribuerNonTreated.length > 0) {
    // Ajouter les activités réattribuées et non traitées en premier
    reattribuerNonTreated.forEach(act => {
      if (activities[act.nom]) {
        reorganizedActivities[act.nom] = activities[act.nom];
      }
    });

    // Ajouter les autres activités
    Object.keys(activities).forEach(activityName => {
      if (!reattribuerNonTreated.some(act => act.nom === activityName)) {
        reorganizedActivities[activityName] = activities[activityName];
      }
    });

    return reorganizedActivities;
  }
  return activities;
};


export const isActivityReattributed = (activityName, activitesInfos) => {
  if (!activityName || !activitesInfos) return false;
  // Trouver toutes les occurrences de l'activité dans le deuxième objet
  const activityInstances = activitesInfos.filter(a => a.nom === activityName);

  // Vérifier s'il existe une occurrence non réattribuée
  const hasNonReattributed = activityInstances.some(a => !a.reattribuer);

  // S'il y a une occurrence non réattribuée, retourner false
  if (hasNonReattributed) {
    return false;
  }

  // Sinon, vérifier s'il y a au moins une occurrence réattribuée
  const hasReattributed = activityInstances.some(a => a.reattribuer);

  return hasReattributed;
};


// Vérifie si une activité est refusée ou non
export const isActivityRefused = (activityNom, activitesInfos, dataFrom) => {
  if (!activityNom || !activitesInfos) return false;
  if (dataFrom === "selectionDates") return false;
  const activite = activitesInfos.find((a) => a.nom === activityNom);
  return activite?.refus ? true : false;
};

const sortedAlaisActivities = (array) => {
  return array
    .slice() // Crée une copie du tableau pour éviter les effets secondaires
    .sort((a, b) => {
      // Fonction de comparaison pour trier les heures
      const [aHour, aMinute] = a.Alias.split(':').map(Number);
      const [bHour, bMinute] = b.Alias.split(':').map(Number);
      return aHour - bHour || aMinute - bMinute;
    })
};



export default function AffichageSelctDate({ groupedActivities, activitesInfos, dataFrom, }) {
  const isEmpty = Object.keys(groupedActivities).length === 0;

  groupedActivities = reorganizeActivities(groupedActivities, activitesInfos);
  const styleTheme = useStylesThemes()();
  let index = 0;
  return (
    <>
      {Object.keys(groupedActivities).map((parentNom) => {
        if (!isActivityReattributed(parentNom, activitesInfos)) {
          index += 1;
        }
        return (
          <Card key={parentNom} style={{ marginTop: 20 }} elevation={0}>
            <CardContent
              style={{
                borderTop: "1px solid #b7b7b7",
              }}
            >
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  {index > 0 && <Box
                    className={styleTheme.badge}
                  // isActivityRefused(parentNom, activitesInfos, dataFrom) ? styleTheme.badgeRefus : styleTheme.badge
                  >
                    <Typography variant="body2">{index}</Typography>
                  </Box>}
                </Grid>
                <Grid item>
                  <Typography
                    variant="h5"
                    style={{
                      marginBottom: 10,
                      fontWeight: "bold",
                      paddingTop: 8,
                      marginLeft: 8,
                      fontSize: 20,
                    }}
                  >
                    {parentNom}
                    {/* {isActivityRefused(parentNom, activitesInfos, dataFrom) ? " (refus)" : ""}
                    {isActivityReattributed(parentNom, activitesInfos) ? " (réattribué)" : ""} */}
                  </Typography>
                </Grid>
              </Grid>
              {Object.keys(groupedActivities[parentNom]).map((longDate) => (
                <Grid
                  key={longDate}
                  container
                  direction="column"
                  style={{ marginBottom: 10 }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      marginBottom: 5,
                      fontSize: 16,
                      marginLeft: 8,
                      fontWeight: "bold",
                    }}
                  >
                    {longDate} { }
                  </Typography>
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {sortedAlaisActivities(groupedActivities[parentNom][longDate]).map((activity) => (
                      <Typography
                        key={activity.ID}
                        style={{
                          display: "inline-block",
                          margin: "3px 3px",
                          padding: "5px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "4px",
                          whiteSpace: "nowrap",
                          fontSize: 14,
                        }}
                        variant="body2"
                      >
                        {activity.Alias}
                      </Typography>
                    ))}
                  </Grid>
                </Grid>
              ))}
            </CardContent>
          </Card>
        )
      })}
      {isEmpty && (
        <Alert severity="info" style={{ marginTop: 32 }}>
          {" "}
          <AlertTitle>
            <strong>Aucune activité sélectionnée !</strong>
          </AlertTitle>
          Veuillez sélectionner une activité et des tranches horaires.
        </Alert>
      )}
    </>
  );
}
